<template>
    <Teleport to="body">
        <Transition name="fade">
            <div
                v-if="props.open"
                :class="[
                    'fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-visible',
                    props.overlayClass,
                ]"
            >
                <div class="max-h-[90vh]">
                    <div :class="['relative', props.contentClass]">
                        <!-- Close Button -->
                        <div v-if="!props.hideClose">
                            <CraneButton
                                class="p-0 float-right aspect-square top-3 right-3 cursor-pointer"
                                :disabled="props.inProgress"
                                variant="ghost"
                                @click="$emit('close')"
                            >
                                <img src="@/assets/x.svg" width="20" height="20" />
                            </CraneButton>
                        </div>
                        <!-- Title -->
                        <div class="text-xl text-primary font-semibold">
                            {{ props.title }}
                        </div>

                        <!-- Body -->
                        <div :class="['flex-1 overflow-y-auto', hasFooter ? 'mb-6' : '']">
                            <slot name="body" />
                        </div>

                        <!-- Footer -->
                        <div v-if="hasFooter" class="flex justify-end gap-2 shrink-0">
                            <slot name="footer" />
                        </div>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup lang="ts">
import CraneButton from '@/components/shared/CraneButton.vue'

// emits events
defineEmits(['close'])
// PROPS DEFINITION
// defineProps<{
//     open: boolean
//     title: string
//     class?: string
// }>()

const props = withDefaults(
    defineProps<{
        open?: boolean
        inProgress?: boolean
        title?: string
        overlayClass?: string
        contentClass?: string
        hideClose?: boolean
    }>(),
    {
        open: false,
        inProgress: false,
        title: '',
        overlayClass: '',
        contentClass: '',
        hideClose: false,
    }
)

const slots = useSlots()

const hasFooter = computed(() => !!slots.footer)
</script>

<style scoped>
/* Component-specific styles */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
